import { render } from "./PegComponent.vue?vue&type=template&id=792ef7ea"
import script from "./PegComponent.js?vue&type=script&lang=js"
export * from "./PegComponent.js?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__